module.exports = {
    解析打印模版: function (模版 = '', 数据 = {}) {
        //解析jo数据
        模版 = 模版.replace(/\r/g, '').replace(/\n/g, '');   //先去掉换行,  换行会影响正则
        if (Array.isArray(数据)) throw '解析模版的数据只能为JObject类型';

        return this.解析jo数据(模版, 数据);
    },
    解析jo数据: function (模版, jo数据) {
        for (const key in jo数据) {
            const value = jo数据[key];
            if (Array.isArray(value)) {  //typeof value=='object' && 
                模版 = this.解析ja数据(模版, value, key);
            }
        }
        //先解析jo里面的内容,解析完了,才能解析ja  避免jo里面的ja的可以跟外层ja的key相同
        for (const key in jo数据) {
            let value = jo数据[key];
            if (Array.isArray(value)) continue;
            if (typeof value == 'object') {
                for (const key2 in value) {
                    const value2 = value[key2];
                    模版 = 模版.replace(new RegExp('{{' + key + '.' + key2 + '}}', 'g'), value2);
                }
                continue;
            }
            模版 = 模版.replace(new RegExp('{{' + key + '}}', 'g'), value);

            //小数格式化
            if (key.startsWith('F_')) {
                value = parseFloat(value);
                模版 = 模版.replace(new RegExp('{{' + key + '.toFixed\\(2\\)}}', 'g'), value.toFixed(2));
                模版 = 模版.replace(new RegExp('{{' + key + '.toFixed\\(4\\)}}', 'g'), value.toFixed(4));
            }
        }
        //去除掉未解析的{}
        模版 = 模版.replace(/\{\{(.*?)\}\}/g, '');
        return 模版;
    },
    解析ja数据: function (模版, ja数据, name) {
        let tmpstr = '/\\{\\{' + name + '(.*?)\\}\\}(.*?)\\{\\{\\/' + name + '\\}\\}/';
        let 正则结果 = eval(tmpstr).exec(模版);
        if (!正则结果) return 模版;
        let 条件str = 正则结果[1];
        let 重复str = 正则结果[2];
        let str = '';
        if (条件str && 条件str.startsWith('|')) {
            let 条数 = 条件str.replace('|', '');
            条数 = parseInt(条数);
            if (条数 > 0 && ja数据.length % 条数 != 0) {
                let 补充数量 = 条数 - ja数据.length % 条数;
                console.log(条件str, '补充数量', 补充数量);
                for (let index = 0; index < 补充数量; index++) {
                    ja数据.push({});
                }
            }
        }
        ja数据.forEach((jo, index) => {
            jo['\\$index'] = index + 1;
            str += this.解析jo数据(重复str, jo);
        });
        return 模版.replace(正则结果[0], str);
    },

    选择打印机: function () {
        return new Promise((resolve, reject) => {
            if (!window.LODOP) reject('请先<a target="_blank" href="https://soft.ydcxt.com/CLodop_Setup_for_Win32NT.exe">安装web打印服务C-Lodop</a>，安装完毕后刷新网页!');
            window.LODOP.On_Return = function (TaskID, Value) {
                if (Value >= 0) {
                    resolve(Value);
                } else {
                    reject();
                }
            };
            window.LODOP.SELECT_PRINTER();
        });
    },
    打印: function (str) {
        return new Promise((resolve, reject) => {
            try {
                this.检查打印控件();
                window.LODOP.SET_PRINT_MODE("SEND_RAW_DATA_ENCODE", "GBK");
                window.LODOP.On_Return = function (TaskID, Value) {
                    if (Value) {
                        resolve(Value);
                    } else {
                        reject();
                    }
                };
                window.LODOP.SEND_PRINT_RAWDATA(str);
            } catch (error) {
                reject(error.message || error)
            }
        });
    },
    预览: function (str, 纸张类型 = 1, 宽度 = 2410, 高度 = 1400) {
        return new Promise((resolve, reject) => {
            try {
                this.检查打印控件();
                let LODOP = window.LODOP;
                window.LODOP.PRINT_INIT("打印任务名");
                //window.LODOP.PRINT_INITA(0, 0, 2410, 1400, "打印控件功能演示_Lodop功能_自定义纸张1");
                window.LODOP.SET_PRINT_PAGESIZE(纸张类型, 宽度, 高度);
                

                if (Array.isArray(str)) {
                    str.forEach((e, index) => {
                        
                        // const pages = this.拆分订单打印HTML(e, 10); // 每页 10 条数据

                        // pages.forEach((pageHtml, index) => {
                        //     window.LODOP.NewPageA();
                        //     window.LODOP.ADD_PRINT_TABLE("0mm", "0mm", "100%", "90%", pageHtml);
                        
                        //     window.LODOP.ADD_PRINT_HTM(
                        //         "97%", "92%", "8%", "3%",
                        //         `第<font tdata='pageNO'>${index+1}</font>页`
                        //     );
                        // });
                        
                        if (index > 0) {
                            window.LODOP.NewPageA();
                        }
                        // 添加主要内容
                        window.LODOP.ADD_PRINT_TABLE("0mm", "0mm", "100%", "90%", e);
                        // 将整行作为页脚区域，内容右对齐 —— 最靠右下角
                        window.LODOP.ADD_PRINT_HTM(
                            "97%",    // 距离页面顶部 97%（靠近底部，可根据实际微调为95%~98%）
                            "85%",     // 从左边 0% 开始，整行宽度由下一个参数决定
                            "15%",   // 宽度 100%（占满整行）
                            "3%",     // 高度 3%（页脚高度，按需调整）
                            "第<font tdata='pageNO'>##</font>页 / 共<font tdata='pageCOUNT'>##</font>页"
                        );
                        
                        // 设置为页脚，右对齐
                        window.LODOP.SET_PRINT_STYLEA(0, "ItemType", 1);   // 固定在页脚（每页显示）
                        window.LODOP.SET_PRINT_STYLEA(0, "Alignment", 3);  // 右对齐文本
                    });
                } else {
                    window.LODOP.ADD_PRINT_TABLE(0, 0, "100%", "100%", str)
                }

                window.LODOP.PREVIEW();
                window.LODOP.On_Return = function (TaskID, Value) {
                    if (parseInt(Value)) {
                        resolve(Value);
                    } else {
                        reject();
                    }
                };
            } catch (error) {
                reject(error.message || error)
            }
        });
    },
    检查打印控件: function (resolve, reject) {
        if (!window.LODOP) {
            try {
                let script3 = document.createElement('script')
                script3.type = 'text/javascript'
                script3.src = 'https://localhost:8443/CLodopFuncs.js'
                document.getElementById("app").appendChild(script3)
                //向网页中插入script
                let script = document.createElement('script')
                script.type = 'text/javascript'
                script.src = 'http://localhost:18000/CLodopFuncs.js'
                document.getElementById("app").appendChild(script)

                let script2 = document.createElement('script')
                script2.type = 'text/javascript'
                script2.src = 'http://localhost:8000/CLodopFuncs.js'
                document.getElementById("app").appendChild(script2)
            } catch (error) {
                console.log(error);
            }
        }

        if (!window.LODOP) {
            throw '请先<a target="_blank" href="https://soft.ydcxt.com/CLodop_Setup_for_Win32NT.exe">安装web打印服务C-Lodop</a>，安装完毕后刷新网页!';
        }
    },
    拆分订单打印HTML:function (htmlStr) {
        const wrapper = document.createElement("div");
        wrapper.innerHTML = htmlStr;

        const table = wrapper.querySelector("table.print_table");
        if (!table) return [htmlStr];

        const rows = Array.from(table.querySelectorAll("tbody tr"));
        const pages = [];

        const thead = table.querySelector("thead");
        const tfoot = table.querySelector("tfoot");

        // 保留其他非 table 元素
        const otherElements = Array.from(wrapper.childNodes).filter(
            node => node.tagName !== "TABLE"
        );

        console.log('到这是什么',rows)

        for (let i = 0; i < rows.length; i += 11) {
            const subTable = document.createElement("table");
            subTable.className = table.className;

            // 添加表头
            if (thead) subTable.appendChild(thead.cloneNode(true));

            // 添加当前页表格行
            const tbody = document.createElement("tbody");
            rows.slice(i, i + 11).forEach(tr => tbody.appendChild(tr.cloneNode(true)));
            subTable.appendChild(tbody);

            // 添加 tfoot，但不要包含页码
            if (tfoot) {
                const tfootClone = tfoot.cloneNode(true);
                // 可以删除原本的页码标签或者特定 class
                tfootClone.querySelectorAll(".pageNO, .页码类").forEach(el => el.remove());
                subTable.appendChild(tfootClone);
            }

            // 每页 wrapper
            const pageWrapper = document.createElement("div");
            otherElements.forEach(node => pageWrapper.appendChild(node.cloneNode(true)));
            pageWrapper.appendChild(subTable);

            pages.push(pageWrapper.innerHTML);
        }

        return pages;
    }
}